import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-6" }
const _hoisted_2 = { class: "md:col-span-8" }
const _hoisted_3 = { class: "md:col-span-4" }
const _hoisted_4 = { class: "md:col-span-6" }
const _hoisted_5 = { class: "md:col-span-6" }
const _hoisted_6 = { class: "md:col-span-6" }
const _hoisted_7 = { class: "md:col-span-6" }
const _hoisted_8 = { class: "md:col-span-6" }
const _hoisted_9 = { class: "md:col-span-6" }
const _hoisted_10 = { class: "md:col-span-6" }
const _hoisted_11 = { class: "md:col-span-4" }
const _hoisted_12 = { class: "md:col-span-8" }
const _hoisted_13 = { class: "md:col-span-12" }

import { ref } from 'vue'
import GenericInput from '@/components/designSystem/Inputs/GenericInput.vue'
import OperationalGroupSelect from '@/components/designSystem/Select/OperationalGroupSelect.vue'
import type { SelectOption } from '@/types'
import type { OperationalGroup } from '@/Network/Types/Responses/ScheduleUnitResponses'
import { injectHealthUnitForm } from '../../composables/useHealthUnitForm'
import { maskPhoneInput } from '../../helpers/phone'
import { maskCnpjInput } from '../../helpers/cnpj'
import { syncMaskedInput } from '../../helpers/maskedInput'
import type { MaskedField } from '../../helpers/maskedInput'
import { HEALTH_UNIT_TYPE_OPTIONS, HealthUnitType } from '../../unitType'
import UnitFormSection from './UnitFormSection.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'UnitGeneralFields',
  props: {
    disabled: { type: Boolean },
    companies: {},
    operationalGroups: {},
    companySelected: {},
    operationalGroup: {}
  },
  emits: ["update:companySelected", "update:operationalGroup"],
  setup(__props: any, { emit }) {





const { form, validate, rules } = injectHealthUnitForm()

const phoneField = ref<MaskedField>(null)
const cnpjField = ref<MaskedField>(null)

function onPhoneInput(value: string | number | undefined): void {
  const masked = maskPhoneInput(value)
  form.values.mainPhone = masked
  syncMaskedInput(phoneField, masked)
}

/** O tipo define o preset de raio sugerido no modal de localização (PR seguinte). */
function onTypeChange(value: HealthUnitType | null): void {
  form.values.type = value ?? undefined
  validate('type')
}

function onCnpjInput(value: string | number | undefined): void {
  const masked = maskCnpjInput(value)
  form.values.cnpj = masked
  syncMaskedInput(cnpjField, masked)
}

return (_ctx: any,_cache: any) => {
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(UnitFormSection, { title: "Identificação" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(GenericInput, {
            disabled: _ctx.disabled,
            rules: [_unref(rules).form('name')],
            width: "100%",
            label: "Nome",
            modelValue: _unref(form).values.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).values.name) = $event)),
            onValidate: _cache[1] || (_cache[1] = ($event: any) => (_unref(validate)('name'))),
            required: "",
            "data-testid": "unit-name-input"
          }, null, 8, ["disabled", "rules", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(GenericInput, {
            disabled: _ctx.disabled,
            width: "100%",
            label: "CNPJ",
            required: "",
            ref_key: "cnpjField",
            ref: cnpjField,
            "model-value": _unref(form).values.cnpj,
            "onUpdate:modelValue": onCnpjInput,
            onValidate: _cache[2] || (_cache[2] = ($event: any) => (_unref(validate)('cnpj'))),
            error: !!_unref(form).errors.cnpj,
            "error-messages": _unref(form).errors.cnpj,
            "data-testid": "unit-cnpj-input"
          }, null, 8, ["disabled", "model-value", "error", "error-messages"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_v_autocomplete, {
            disabled: _ctx.disabled,
            "model-value": _ctx.companySelected,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (emit('update:companySelected', $event))),
            class: "w-full",
            color: "primary20",
            label: "* Empresa",
            items: _ctx.companies,
            variant: "outlined",
            "data-testid": "unit-company-select"
          }, null, 8, ["disabled", "model-value", "items"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_v_select, {
            disabled: _ctx.disabled,
            "model-value": _unref(form).values.type,
            "onUpdate:modelValue": onTypeChange,
            class: "w-full",
            color: "primary20",
            label: "* Tipo de unidade",
            items: _unref(HEALTH_UNIT_TYPE_OPTIONS),
            "item-title": "title",
            "item-value": "value",
            variant: "outlined",
            "error-messages": _unref(form).errors.type || undefined,
            "data-testid": "unit-type-select"
          }, null, 8, ["disabled", "model-value", "items", "error-messages"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(OperationalGroupSelect, {
            "model-value": _ctx.operationalGroup,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (emit('update:operationalGroup', $event))),
            items: _ctx.operationalGroups,
            disabled: _ctx.disabled,
            label: "* Grupo Operacional",
            density: "default",
            error: !!_unref(form).errors.operationalGroup,
            "error-messages": _unref(form).errors.operationalGroup,
            variant: "outlined",
            "data-testid": "unit-operational-group-select"
          }, null, 8, ["model-value", "items", "disabled", "error", "error-messages"])
        ])
      ]),
      _: 1
    }),
    _createVNode(UnitFormSection, {
      title: "Contato e responsáveis",
      hint: "opcional"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(GenericInput, {
            disabled: _ctx.disabled,
            label: "Email",
            rules: [_unref(rules).form('email')],
            width: "100%",
            modelValue: _unref(form).values.email,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).values.email) = $event)),
            onValidate: _cache[6] || (_cache[6] = ($event: any) => (_unref(validate)('email'))),
            "data-testid": "unit-email-input"
          }, null, 8, ["disabled", "rules", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(GenericInput, {
            disabled: _ctx.disabled,
            label: "Telefone",
            width: "100%",
            ref_key: "phoneField",
            ref: phoneField,
            "model-value": _unref(form).values.mainPhone,
            "onUpdate:modelValue": onPhoneInput,
            onValidate: _cache[7] || (_cache[7] = ($event: any) => (_unref(validate)('mainPhone'))),
            error: !!_unref(form).errors.mainPhone,
            "error-messages": _unref(form).errors.mainPhone,
            "data-testid": "unit-phone-input"
          }, null, 8, ["disabled", "model-value", "error", "error-messages"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(GenericInput, {
            disabled: _ctx.disabled,
            label: "Coordenação técnica",
            rules: [_unref(rules).form('technicalManager')],
            width: "100%",
            modelValue: _unref(form).values.technicalManager,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(form).values.technicalManager) = $event)),
            onValidate: _cache[9] || (_cache[9] = ($event: any) => (_unref(validate)('technicalManager'))),
            "data-testid": "unit-technical-manager-input"
          }, null, 8, ["disabled", "rules", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(GenericInput, {
            disabled: _ctx.disabled,
            label: "Gerência Geral",
            rules: [_unref(rules).form('generalManager')],
            width: "100%",
            modelValue: _unref(form).values.generalManager,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(form).values.generalManager) = $event)),
            onValidate: _cache[11] || (_cache[11] = ($event: any) => (_unref(validate)('generalManager'))),
            "data-testid": "unit-general-manager-input"
          }, null, 8, ["disabled", "rules", "modelValue"])
        ])
      ]),
      _: 1
    }),
    _createVNode(UnitFormSection, {
      title: "Informações adicionais",
      hint: "opcional"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(GenericInput, {
            disabled: _ctx.disabled,
            type: "number",
            label: "Total de funcionários",
            rules: [_unref(rules).form('quantityColaborators')],
            width: "100%",
            modelValue: _unref(form).values.quantityColaborators,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(form).values.quantityColaborators) = $event)),
            onValidate: _cache[13] || (_cache[13] = ($event: any) => (_unref(validate)('quantityColaborators'))),
            "data-testid": "unit-employees-input"
          }, null, 8, ["disabled", "rules", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(GenericInput, {
            disabled: _ctx.disabled,
            label: "Perfil",
            rules: [_unref(rules).form('profile')],
            width: "100%",
            modelValue: _unref(form).values.profile,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(form).values.profile) = $event)),
            onValidate: _cache[15] || (_cache[15] = ($event: any) => (_unref(validate)('profile'))),
            "data-testid": "unit-profile-input"
          }, null, 8, ["disabled", "rules", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(GenericInput, {
            disabled: _ctx.disabled,
            label: "Link do Waze",
            rules: [_unref(rules).form('linkWaze')],
            width: "100%",
            modelValue: _unref(form).values.linkWaze,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(form).values.linkWaze) = $event)),
            onValidate: _cache[17] || (_cache[17] = ($event: any) => (_unref(validate)('linkWaze'))),
            "data-testid": "unit-waze-input"
          }, null, 8, ["disabled", "rules", "modelValue"])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})